export const postBiz = async (payload: any) => {
  const res = await fetch('/biz', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  const json = await res.json();
  if (!res.ok || json.failure) throw new Error(json.em || json.message || 'Request failed');
  return json;
};

const rows = (json: any) => {
  const sd = json.sd || json.result?.sd || json.data?.sd;
  return Array.isArray(sd) ? sd : [];
};

export const createForecastBatch = (fyr:string, scc:string, fnm:string, wbm:any) =>
  postBiz({ s:'bieforecast', a:'createbatch', fyr, scc, fnm, wbm });

export const saveForecastSheets = (rid:number, sht:any[]) =>
  postBiz({ s:'bieforecast', a:'savesheets', rid, sht });

export const saveForecastMetrics = (rid:number, rcd:any[]) =>
  postBiz({ s:'bieforecast', a:'savemetrics', rid, rcd });

export const fetchForecastPayload = (rid:number) =>
  postBiz({ s:'bieforecast', a:'payload', rid });

export const fetchForecastBatches = async (fyr='', ist='') =>
  rows(await postBiz({ s:'bieforecast', a:'find', fyr:fyr || null, ist:ist || null, pgo:0, pgl:100 }));

export const fetchForecastMetrics = async (rid:number, mtc='') =>
  rows(await postBiz({ s:'bieforecast', a:'metrics', rid, mtc:mtc || null }));

export const submitPayloadToBieImport = (sourceCode:string, scenarioCode:string, filename:string, records:any[]) =>
  postBiz({
    s:'bieimport',
    a:'universal',
    trk:null,
    soc:sourceCode,
    scc:scenarioCode,
    rcd:records.map((r:any) => ({ scc:scenarioCode, ...r })),
    fnm:filename,
    fdt:{},
    att:{},
    exi:{ origin:'BIE Determinant Forecast Engine' },
    rmk:'Forecast-generated BIE import from determinant budget workbook',
  });


